import { action, computed, observable } from 'mobx';

const error = {
  error: '',
  data: {},
};

export default class BuyerAgentInviteStore {
  @observable sale;
  @observable data;
  @observable submitError = error;

  constructor(sale) {
    this.sale = sale;
    this.data = {};
  }

  @computed get phoneNumberError() {
    return this.submitError.error &&
      this.submitError.data.phoneNumber === this.data.phoneNumber &&
      this.submitError.error.startsWith('phone_number_')
      ? `phonenumbererror::${this.submitError.error.substring(
          'phone_number_'.length
        )}`
      : '';
  }

  @action setData(data) {
    this.data = Object.assign({}, data);
  }

  invite = () => {
    const { saleEdit, ui } = this.sale;

    this.submitError.error = '';
    if (this.data.locale === '') {
      this.data.locale = saleEdit.locale;
    }

    saleEdit.inviteBuyerAgent(this.data).then(
      () => {
        ui.closePanel();
      },
      (error) => {
        if (
          error &&
          error.response &&
          error.response.result &&
          !error.response.result.successful &&
          error.response.result.error
        ) {
          this.submitError.error = error.response.result.error;
          this.submitError.data = this.data;
        } else {
          saleEdit.root.failed(error);
          ui.closePanel();
        }
      }
    );
  };

  close = async () => {
    this.sale.ui.closePanel();
  };

  propChanged = (field, value, customValue) => {
    const valueKey = !!value ? value.key : undefined;
    this.data[field] = customValue || valueKey || value;
  };

  titleChanged = (option, value) => {
    this.data.title = option ? option.text : value;
  };
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/BuyerAgentInviteSection/stores/index.js